import { Flex, Heading, Button, FormControl, FormLabel, Box, RadioGroup, Radio } from '@chakra-ui/react'; 
import { useNavigate, useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb';
import CustomInput from '../../../../components/common/Input/input';
import * as api from '../../../../api/tipoMidia';
import Swal from 'sweetalert2';

function EditarTipoMidia() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [formValues, setFormValues] = useState({
    dscMidia: { value: '', error: false },
    codMidia: { value: '', error: false },
    numRegistro: { value: 0, error: false }
  });

  const fetchTipoMidia = async () => {
    if (!id) return;

    try {
      const data = await api.obterTipoMidia(Number(id));
      setFormValues({
        dscMidia: { value: data.dscMidia, error: false },
        codMidia: { value: data.codMidia, error: false },
        numRegistro: { value: data.numRegistro, error: false }
      });
    } catch (error) {
      console.error('Erro ao obter tipo de mídia:', error);
    }
  };

  useEffect(() => {
    fetchTipoMidia();
  }, [id]);

  const isFormValid = () => {
    const { dscMidia } = formValues;
    return dscMidia.value.trim().length >= 3;
  };

  const handleFieldChange = (field: string, value: any) => {
    setFormValues({
      ...formValues,
      [field]: { error: false, value }
    });
  };

  const handleSubmit = async () => {
    const { dscMidia, codMidia, numRegistro } = formValues;

    const params = {
      dscMidia: dscMidia.value.trim() !== '' ? dscMidia.value : null,
      codMidia: codMidia.value || null,
      numRegistro: numRegistro.value
    };

    try {
      await api.editarTipoMidia(Number(id), params);
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Tipo de mídia editada com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/configuracao/gerenciar-tipo-midia');
      });
    } catch (error) {
      console.error('Erro ao editar tipo de mídia:', error);
      Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: 'Erro ao editar tipo de mídia. Tente novamente mais tarde.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/configuracao/gerenciar-tipo-midia');
      });
    }
  };

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <SettingsBreadcrumb />
      <Heading mt="30px" mb="20px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Editar Tipo de Mídia
      </Heading>
      <div className="row mb-3">
        <div className="col-md-6 mb-4">
          <FormControl isRequired>
            <FormLabel mb="8px">Descrição</FormLabel>
            <CustomInput
              placeholder='Digite uma descrição'
              value={formValues.dscMidia.value}
              onChange={(e) => handleFieldChange('dscMidia', e.target.value)}
              maxLength={20}
            />
          </FormControl>
        </div>
      </div>

      <Box alignItems={'flex-end'}>
        <Button m="px" onClick={() => navigate(-1)}>
          Desistir
        </Button>
        <Button
          m="6px"
          color="#FFF"
          bgColor="#1665D8"
          _hover={{ opacity: 0.8 }}
          onClick={handleSubmit}
          isDisabled={!isFormValid()}
        >
          Editar Tipo de Mídia
        </Button>
      </Box>
    </Flex>
  );
}

export default EditarTipoMidia;
